export default __webpack_public_path__ + "static/media/icon-close.0e1b64f3.svg";